import { Facebook, Globe2, ThumbsUp, MessageCircle, Share2 } from "lucide-react";
import type { PreviewProps } from "../types";
import { PreviewShell, MediaSlot, MediaCarousel } from "./PreviewShell";

export function FacebookPreview(props: PreviewProps) {
  return (
    <PreviewShell device={props.device}>
      <div className="flex items-center gap-2.5 p-3">
        {props.pageAvatarUrl ? (
          <img
            src={props.pageAvatarUrl}
            alt={props.pageName}
            className="w-10 h-10 rounded-full object-cover bg-gray-100"
          />
        ) : (
          <div className="w-10 h-10 rounded-full flex items-center justify-center bg-blue-50">
            <Facebook size={18} className="text-[#1877F2]" />
          </div>
        )}
        <div className="flex-1 min-w-0">
          <p className="text-[13px] font-semibold text-gray-900 truncate">{props.pageName}</p>
          <p className="text-[11px] text-gray-400 flex items-center gap-1">
            <Globe2 size={10} /> {new Date().toLocaleDateString()}
          </p>
        </div>
        <span className="text-gray-300 text-lg">···</span>
      </div>
      {props.caption && (
        <div className="px-3 pb-2">
          <p className="text-[12px] text-gray-800 whitespace-pre-wrap leading-relaxed">
            {props.caption}
          </p>
        </div>
      )}
      {props.mediaUrls && props.mediaUrls.length > 1 ? (
        <MediaCarousel mediaUrls={props.mediaUrls} aspect="aspect-[4/3]" />
      ) : (
        <MediaSlot mediaUrl={props.mediaUrl} mediaType={props.mediaType} aspect="aspect-[4/3]" />
      )}
      <div className="flex items-center justify-around py-2.5 border-t border-gray-100 text-[11px] text-gray-500">
        <span className="flex items-center gap-1.5">
          <ThumbsUp size={13} /> Like
        </span>
        <span className="flex items-center gap-1.5">
          <MessageCircle size={13} /> Comment
        </span>
        <span className="flex items-center gap-1.5">
          <Share2 size={13} /> Share
        </span>
      </div>
    </PreviewShell>
  );
}
